import VotePinIcon from './VotePinIcon'

export default VotePinIcon
